export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-background-900 to-background-800 rounded-2xl p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">移动追剧</h2>
            <p className="text-sm text-background-300 leading-relaxed max-w-[480px] lg:max-w-none">
              亚洲影视网 APP 已上架各大应用商店，支持安卓和 iOS 系统。随时随地免费看全集高清电视剧，离线缓存功能让你在无网络环境下也能畅快追剧。同样免费且无广告，和网页版完全一致。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <div className="flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 rounded-lg cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-android-line text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">Android 下载</span>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 rounded-lg cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">iOS 下载</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-5">
              <div className="text-center">
                <div className="text-lg font-bold text-accent-400">500万+</div>
                <div className="text-[11px] text-background-400">累计下载</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-accent-400">4.8 分</div>
                <div className="text-[11px] text-background-400">用户评分</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-accent-400">离线缓存</div>
                <div className="text-[11px] text-background-400">特色功能</div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="aspect-[9/16] bg-background-700 rounded-2xl overflow-hidden border-4 border-background-600">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20app%20screen%20mockup%20showing%20Asian%20TV%20drama%20streaming%20interface%20with%20drama%20posters%20grid%2C%20clean%20dark%20UI%20design%2C%20red%20and%20gold%20accents%2C%20modern%20mobile%20layout%2C%20smooth%20rounded%20corners%2C%20professional%20app%20design%20aesthetic&width=450&height=800&seq=app-mockup-screen&orientation=portrait"
                alt="亚洲影视网手机APP追剧界面"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}